import { IconButton } from "../../components";
import { openCloseLoopFiltersModal } from "../../components/modals/close-loop-filter";
import { FiltersAppliedWarningMessage, Main, PageHeader, PageSubHeader, ThemedIcon } from "../../components/utilities";
import { PageHeaderTitle } from "../../components/utilities/PageHeader";
import { CloseLoopDashboard, CloseLoopGridDataProvider, useCloseLoopGridData } from "../../features/closeloopdashboard";
import { CloseLoopDashboardDefaultFilters, FilterProvider, useFilterContext } from "../../hooks/FilterContext";
import withProviders from "../../hooks/withProviders";
import Wp3Dropdown from "../../components/utilities/Dropdown";

const CloseLoopDashboardPage = ({ title = "Close Loop" }) => {
    const { clearFilter, isFiltersApplied, filter, setFilter } = useFilterContext();
    const { confirmExport } = useCloseLoopGridData();

    const openFilter = () => {
        openCloseLoopFiltersModal(filter)
            .then(form => setFilter(form));
    }

    return <>
        <PageHeader>
            <PageHeaderTitle>
                <span>{title}</span>
            </PageHeaderTitle>
        </PageHeader>
        <Main className="d-flex flex-column">
            <PageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {isFiltersApplied && (
                            <>
                                <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                <FiltersAppliedWarningMessage className="ms-2 text-muted">
                                    Warning - Filters are currently being applied to your results.
                                    <br />
                                    <button className="anchor" onClick={clearFilter}>Click here</button> to clear your filters.
                                </FiltersAppliedWarningMessage>
                            </>
                        )}
                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                        <IconButton
                            icon={['fas', 'filter']}
                            onClick={openFilter}
                            menu={[
                                <Wp3Dropdown.Menu>
                                    <Wp3Dropdown.MenuItem 
                                        icon={"file-export"}
                                        text="Export Close Loop letters"
                                        onClick={() => confirmExport()}
                                    />
                                </Wp3Dropdown.Menu>
                            ]}
                        >
                            Filter Applications
                        </IconButton>
                    </div>
                </div>
            </PageSubHeader>
            <section className="px-4 my-3 h-100">
                <CloseLoopDashboard />
            </section>
        </Main>
    </>
}

export default withProviders(
    [FilterProvider, { filterStore: "hocloseloop", defaultFilters: CloseLoopDashboardDefaultFilters }],
    [CloseLoopGridDataProvider]
)(CloseLoopDashboardPage);